class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.init();
        this.addEventListener('change', this.onVariantChange);
    }

    init() {
        window.hasVariants = true;
        this.updateOptions();
        this.updateMasterId();
        this.setCurrentMedia();
        window.addEventListener("load", () => {
            this.thumbnailEventListeners(true);
        })
    }
  
    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
  
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.thumbnailEventListeners();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }
  
    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    setCurrentMedia() {
        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        const mediaGalleryThumbnails = document.getElementById(`MediaGalleryThumbnails-${this.dataset.section}`);
        const variantImages = document.querySelectorAll('.js-pdp-media-gallery-variant');
        const variantThumbnails = document.querySelectorAll('.js-pdp-media-gallery-thumbnail-variant');

        if(this.currentVariant.featured_media) {
            const mediaVariant = mediaGallery.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
            const mediaVariantThumbnail = mediaGalleryThumbnails.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);

            // Move variant images which aren't the current variant to end of slider
            variantImages?.forEach(image => {
                if (image !== mediaVariant) {
                    mediaGallery.removeChild(image)
                    mediaGallery.insertAdjacentElement('beforeend', image);
                }
            })

            // Move variant thumbnails which aren't the current variant to end of slider
            variantThumbnails?.forEach(thumb => {
                if (thumb !== mediaVariantThumbnail) {
                    mediaGalleryThumbnails.removeChild(thumb)
                    mediaGalleryThumbnails.insertAdjacentElement('beforeend', thumb);
                }
            })
            
            if (mediaVariant && mediaVariantThumbnail) {
                // Remove the current variant <li> element from its current position
                mediaGallery.removeChild(mediaVariant);
                mediaGalleryThumbnails.removeChild(mediaVariantThumbnail);

                // Insert the current variant <li> element at the 1st position (index 0)
                mediaGallery.insertBefore(mediaVariant, mediaGallery.children[0]);
                mediaGalleryThumbnails.insertBefore(mediaVariantThumbnail, mediaGalleryThumbnails.children[0]);
            }
        }

        if (mediaGalleryThumbnails) {
            // Make sure correct thumbnail button is active
            mediaGalleryThumbnails.querySelectorAll('.js-pdp-media-gallery-thumbnail').forEach((btn, index) => {
                if (index == 0) {
                    if (!btn.classList.contains('is-active')) {
                        btn.classList.add('is-active')
                    }
                } else {
                    btn.classList.remove('is-active')
                }
            })
        }
    }

    thumbnailEventListeners() {
        const mediaGalleryThumbnails = document.getElementById(`MediaGalleryThumbnails-${this.dataset.section}`);

        // Re add event listners after DOM change
        if (mediaGalleryThumbnails) {
            mediaGalleryThumbnails.querySelectorAll('.js-pdp-media-gallery-thumbnail').forEach((button, index) => {
                button.addEventListener('click', () => {
                    window.pdpCarousel?.slideTo(index)
                });
            })
        }

        // Slide both carousels to start
        window.pdpCarousel?.slideTo(0);
        window.pdpCarouselThumbnails?.slideTo(0);
    }
  
    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        this.setCurrentMedia();
  
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }
  
    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

        const url = new URL(window.location.href);
        url.pathname = this.dataset.url;
        url.searchParams.set('variant', this.currentVariant.id);

        window.history.replaceState({ }, '', `${url.pathname}${url.search}${url.hash}`);
    }
  
    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, form[id^="product-form-${this.dataset.section}-"]`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (!input) return;

            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
  
    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;
  
        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }
  
    removeErrorMessage() {
        const section = this.closest('.section');
        if (!section) return;
  
        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
        const sectionId = this.dataset.originalSection || this.dataset.section;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${sectionId}`);
                if (source && destination) destination.innerHTML = source.innerHTML;

                const buyButtonsDestination = document.getElementById(`multiple-buy-buttons-${this.dataset.section}`);
                const buyButtonsSource = html.getElementById(`multiple-buy-buttons-${sectionId}`);
                if (buyButtonsSource && buyButtonsDestination) {
                    buyButtonsDestination.innerHTML = buyButtonsSource.innerHTML;
                }
  
                const price = document.getElementById(`price-${this.dataset.section}`);
  
                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
  
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }
  
        if (!modifyClass) return;
    }
  
    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }
  
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

if(!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
  
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        });
    }
}

if(!customElements.get('variant-radios')) {  
    customElements.define('variant-radios', VariantRadios);
}

export {
    VariantSelects,
    VariantRadios
}
